import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import baseUrl from "../../../../api/baseUrl";
import getDecryptedToken from "../../../../api/getDecryptedToken";
import { RootState } from "../../../../redux/store";
import {
  LoggedInClinic,
  doctorFieldsFromEmployee,
  resolveLoggedInClinic,
} from "./getLoggedInClinic";

export function useLoggedInClinic(enabled = true): LoggedInClinic {
  const printClinic = useSelector((state: RootState) => state.print.clinic);
  const [bill, setBill] = useState<any>(null);
  const [doctorFields, setDoctorFields] = useState<Partial<LoggedInClinic>>({});

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    baseUrl
      .get("/clinic/getBillData")
      .then((response) => {
        if (!cancelled) setBill(response?.data?.data ?? null);
      })
      .catch(() => {
        if (!cancelled) setBill(null);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return;
    const eid = getDecryptedToken("eid");
    if (!eid) {
      setDoctorFields({});
      return;
    }
    let cancelled = false;
    baseUrl
      .get("/employee/findEmployeeById", { headers: { employeeid: eid } })
      .then((response) => {
        if (!cancelled) {
          setDoctorFields(doctorFieldsFromEmployee(response?.data?.data ?? null));
        }
      })
      .catch(() => {
        if (!cancelled) setDoctorFields({});
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return useMemo(
    () => resolveLoggedInClinic(bill, printClinic, doctorFields),
    [bill, printClinic, doctorFields]
  );
}
